import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=1aca42c1&"
import script from "./EmptyLayout.vue?vue&type=script&lang=ts&"
export * from "./EmptyLayout.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports